import { render, staticRenderFns } from "./TextFieldWidget.vue?vue&type=template&id=be5e080a&scoped=true&"
import script from "./TextFieldWidget.vue?vue&type=script&lang=ts&"
export * from "./TextFieldWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TextFieldWidget.vue?vue&type=style&index=0&id=be5e080a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5e080a",
  null
  
)

export default component.exports